import { Component, OnInit, Renderer2, Input } from '@angular/core';
import { LoaderService } from 'src/app/service/shared/loader/loader.service';
import { TableData } from 'src/app/shared/models/tableData';
import { JobPointeSettingsService } from 'src/app/service/job-pointe-settings/job-pointe-settings.service';

@Component({
  selector: 'app-add-employee-list',
  templateUrl: './add-employee-list.component.html',
  styleUrls: ['./add-employee-list.component.scss'],
})
export class AddEmployeeListComponent implements OnInit {
  constructor(
    private jobPointeSettingsService: JobPointeSettingsService,
    public renderer2: Renderer2,
    private loaderService: LoaderService,
  ) { }

  @Input() cardData: any;

  modelDetail: any = {
    'asset-classes': {},
    categories: {},
    manufacturers: {},
    enabled: {},
  };

  recentlyAddedEmployees: Set<string> = new Set()

  data: TableData = {
    label: 'Add Employee To Job Board',
    type: 'jobBoardEmployees',
    editAccess: true,
    selectable: false,
    statusToggle: false,
    columns: [
      {
        name: 'name',
        label: 'Name',
        component: 'employee-profile',
        property: () => '',
        sortable: true,
        columnStyles: { 'max-width': 'fit-content' },
        headerStyles: { 'min-width': '6rem' },
        columnClasses: { 'text-truncate': false },
      },
      {
        name: 'jobCount',
        label: 'Jobs',
        component: 'job-count',
        property: row => row?.jobBoardJobs?.length,
        sortable: true,
        columnStyles: { 'max-width': 'fit-content', 'white-space': 'inherit' },
        headerStyles: { 'min-width': 'fit-content' },
        columnClasses: { 'text-truncate': false },
        show: () => true,
      },
      {
        name: 'departmentNumber',
        label: 'Department',
        property: row => row?.employeeDepartment?.shortCode,
        sortable: true,
        columnStyles: { 'max-width': '90px' },
        headerStyles: { 'min-width': '6rem' },
        columnClasses: { 'text-truncate': false },
      },
      /* tslint:disable-next-line curly */
      {
        name: 'type',
        label: 'Type',
        property: row => row?.employeeUnionClass?.name,
        columnStyles: { 'max-width': 'fit-content' },
        headerStyles: { 'max-width': 'fit-content' },
        sortable: true,
        columnClasses: { 'text-truncate': false },
      },
      {
        name: 'city',
        label: 'City',
        property: row => row?.city,
        sortable: true,
        columnStyles: {
          'min-width': 'fit-content',
          'max-width': 'fit-content',
          'white-space': 'inherit',
        },
        headerStyles: { 'min-width': '8rem' },
        columnClasses: { 'text-truncate': false },
      },
      {
        name: 'email',
        label: 'Email',
        property: row => row?.email,
        sortable: true,
        columnStyles: {
          'max-width': '12.5rem',
          'white-space': 'normal',
          'word-wrap': 'break-word'
        },
        headerStyles: { 'min-width': '5rem', 'text-align': 'center' },
        columnClasses: { 'text-truncate': true },
      },
      {
        name: 'phone',
        label: 'Phone',
        property: row => row?.phone,
        sortable: true,
        columnStyles: { 'max-width': 'fit-content', 'text-align': '-webkit-center' },
        headerStyles: { 'min-width': '5rem', 'text-align': 'center' },
        columnClasses: { 'text-truncate': false },
      },
      {
        name: 'status',
        label: 'Status',
        component: 'employee-status',
        property: row => row?.status,
        sortable: true,
        columnStyles: { 'max-width': '110px' },
        headerStyles: { 'min-width': '5rem', 'text-align': 'center' },
        columnClasses: { 'text-truncate': true },
      },
    ],
    rowActions: [
      {
        label: 'Action',
        actionId: 'addEmployeeToCard',
        iconName: row => {
          const hasJobAsCurrentAssignment = row?.currentAssignment?.includes(this.cardData?.facilityName || this.cardData?.jobNumber)

          const isScheduledEmployee = this.cardData.scheduleEmployees.some(el => el.userId === row.id)

          if (row.hasBeenAddedSuccessfully) {
            this.recentlyAddedEmployees.add(row.id)
          }

          const isOnJob = hasJobAsCurrentAssignment || isScheduledEmployee || this.recentlyAddedEmployees.has(row.id)

          return row.addingUser ? 'fa fa-light fa-spinner-third fa-spin' : isOnJob ? 'fa fa-check' : 'fa fa-plus';
        },
        payload: null,
        show: () => true,
      },
    ],
    data: [],
    pagination: {},
    meta: {},
  };

  loadOptions(key: string): void {
    this.jobPointeSettingsService.read[key]().subscribe(
      res => {
        const settings = res.data.reduce((list, item) => {
          list[item.id] = item.name;
          return list;
        }, {});
        this.modelDetail[key] = settings;

        const filter = this.filters.find(f => f.model === key)

        filter.options = res.data;
      },
      error => {
        console.error(error);
        this.loaderService.hideLoader();
      },
    );
  }

  ngOnInit(): void {
    this.data.rowActions.find(r => r.actionId === 'addEmployeeToCard').payload = this.cardData;
  }

  ngAfterViewInit(): void {
    this.loadSelect2();
  }

  loadSelect2() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadSelect2();`;
  }

  filters: Array<any> = [
    {
      label: 'Filter By Department',
      type: 'select2',
      propertyName: 'scope[department]',
      default: '',
      value: 'id',
      name: 'department_name',
      model: 'departments',
      options: [],
      loadOptions: () => this.loadOptions('departments'),
    },
    {
      label: 'Filter By Type',
      type: 'select2',
      propertyName: 'scope[unionClass]',
      default: '',
      value: 'id',
      name: 'name',
      model: 'employeeUnionClasses',
      options: [],
      loadOptions: () => this.loadOptions('employeeUnionClasses'),
    },
    {
      label: 'Filter By Title',
      type: 'select2',
      propertyName: 'scope[employeeTitle]',
      default: '',
      value: 'id',
      name: 'name',
      model: 'employeeTitles',
      options: [],
      loadOptions: () => this.loadOptions('employeeTitles'),
    },
    {
      label: 'Filter By Status',
      type: 'select2',
      propertyName: 'scope[status]',
      default: 1,
      value: 'id',
      name: 'label',
      model: 'status',
      options: [
        { id: 1, label: 'Active', selectedByDefault: true },
        { id: 'false', label: 'Inactive' },
      ],
    },
    {
      label: 'Filter By Certs',
      type: 'autocomplete',
      propertyName: 'scope[jobBoardAttributes]',
      default: '',
      value: 'id',
      name: 'name',
      model: 'jobBoardAttributes',
      options: [],
      loadOptions: () => this.loadOptions('jobBoardAttributes'),
    },
  ];
}
